export interface Logger {
  success(msg: string): void;
  info(msg: string): void;
  warn(msg: string): void;
  error(msg: string, error?: Error): void;
  debug(msg: string): void;
}

export function createNoopLogger(): Logger {
  return {
    success: () => {},
    info: () => {},
    warn: () => {},
    error: () => {},
    debug: () => {},
  };
}
